module.exports = __webpack_public_path__ + "static/TruenoUltBlk-40a34acd257e867f7f38dddb8df73c7b.woff2";